import type { ToolboxMapViewer } from '@onxmaps/ai-toolkit/toolbox'
import { camera, setDestination } from '@/services/map-service'
import Camera from '@/lib/camera'
import Geographic from '@/lib/geographic'

/**
 * Adapts fish-web's `map-service` camera (a synchronous snapshot + a
 * `setDestination` setter) to the toolbox's `ToolboxMapViewer` contract, so
 * the toolbox map tools (mapCamera, mapQueryCard, searchPlaces) can drive it
 * without depending on fish-web's map-service shape directly.
 */
export const mapViewer: ToolboxMapViewer = {
  getCenter: () => {
    const location = camera()?.location
    return [location?.longitude ?? 0, location?.latitude ?? 0]
  },
  getZoom: () => camera()?.location.height ?? 14,
  getBearing: () => camera()?.bearing ?? 0,
  getPitch: () => camera()?.pitch ?? 0,
  // fish-web's setDestination is synchronous; the interface requires a
  // Promise (real map-x viewers ease over time), so resolve immediately.
  easeTo: ({ center, zoom, bearing, pitch }) => {
    const before = camera()
    const currentLocation = before?.location
    const [lon, lat] = center ?? [
      currentLocation?.longitude ?? 0,
      currentLocation?.latitude ?? 0,
    ]
    const newLocation = new Geographic(
      lon,
      lat,
      zoom ?? currentLocation?.height ?? 14
    )
    const newCamera = new Camera({
      location: newLocation,
      bearing: bearing ?? before?.bearing ?? 0,
      pitch: pitch ?? before?.pitch ?? 0,
    })
    setDestination(newCamera)
    return Promise.resolve()
  },
}
